module.exports = __webpack_public_path__ + "static/media/ux-ui-designer-junior.0d81aa32.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/vacancies/ux-ui-designer-junior.jpg
// module id = 359
// module chunks = 0